/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostCostcoProducts201ResponseAllOfData } from './PostCostcoProducts201ResponseAllOfData';
import {
    PostCostcoProducts201ResponseAllOfDataFromJSON,
    PostCostcoProducts201ResponseAllOfDataFromJSONTyped,
    PostCostcoProducts201ResponseAllOfDataToJSON,
} from './PostCostcoProducts201ResponseAllOfData';

/**
 * 
 * @export
 * @interface PostCostcoProducts201ResponseAllOf
 */
export interface PostCostcoProducts201ResponseAllOf {
    /**
     * 
     * @type {PostCostcoProducts201ResponseAllOfData}
     * @memberof PostCostcoProducts201ResponseAllOf
     */
    data: PostCostcoProducts201ResponseAllOfData;
}

/**
 * Check if a given object implements the PostCostcoProducts201ResponseAllOf interface.
 */
export function instanceOfPostCostcoProducts201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function PostCostcoProducts201ResponseAllOfFromJSON(json: any): PostCostcoProducts201ResponseAllOf {
    return PostCostcoProducts201ResponseAllOfFromJSONTyped(json, false);
}

export function PostCostcoProducts201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCostcoProducts201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': PostCostcoProducts201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function PostCostcoProducts201ResponseAllOfToJSON(value?: PostCostcoProducts201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PostCostcoProducts201ResponseAllOfDataToJSON(value.data),
    };
}

